// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader-overlay-1wnOD"};